import type { BookDiscoveryCard } from '../navigation/context'

export type BookCardAnchor = Pick<
  BookDiscoveryCard,
  'id' | 'group_id' | 'context_fund_id' | 'source_client_id' | 'document_ids'
>

export function bookCardAnchor(card: BookDiscoveryCard): BookCardAnchor {
  return {
    id: card.id,
    group_id: card.group_id,
    context_fund_id: card.context_fund_id,
    source_client_id: card.source_client_id,
    document_ids: [...card.document_ids],
  }
}

export function bookContinuation(
  previous: BookCardAnchor,
  cards: readonly BookDiscoveryCard[]
): string | null {
  const documents = [...previous.document_ids].sort().join(':')
  const matches = cards.filter(
    (card) =>
      card.group_id === previous.group_id &&
      card.context_fund_id === previous.context_fund_id &&
      card.source_client_id === previous.source_client_id &&
      [...card.document_ids].sort().join(':') === documents
  )
  return matches.length === 1 ? matches[0].id : null
}
